module.exports = {
  messages: {
    CN: {
      "yes": '是',
      "no": '否',
      "emailAction": '操作',
      account: {
        groupName: '分组名称',
        EnableMessage: '确定要删除吗？',
        rule: '请输入分组名称',
        sarchValuePl: '搜索商品编号或名称',
        selectGroup: '选择商品',
        selectGroup2: '选择得意先',
        selected: '已选：商品',
        goodsName: '得意先名称',
        goodsNumber: '商品编号',
        goodsNumberPl: '请选择商品编号',
        total: '总条数：',
        message1: '列表存在已删除或取引終了的得意先，请删除后重试',
        emptyDyxTip: '请选择筛选条件后查询得意先',
        delete: '删除',
        edit: '编辑',
        searchContent: '商品信息',
        searchPl: '请输入商品编号或名称',
        goodsCount: '商品数量',
        createUser: '创建者',
        updateTime: '更新时间',
        editGoods: '编辑商品分组',
        goodsCla: '商品分类',
        goodsGroup: '商品分组',
        srx: '仕入先',
        tip: '温馨提示',
        tipContent: '保存后指定的商品对游客不再可见，只对以下配置的得意先可见。',
        dyxPl: '搜索得意先编号或名称',
        dyxNumber: '得意先编号',
        ddz: '担当者',
        yetai: '业态',
        status: '状态',
        shangpin: '商品名称',
        editVisible: '编辑商品可见性设置',
        dyxCount: '得意先数量'
      }
    },
    JP: {
      "yes": 'はい',
      "no": 'いいえ',
      "emailAction": '操作',
      account: {
        groupName: 'グループ名',
        EnableMessage: '削除してもよろしいですか？',
        rule: 'グループ名を入力してください',
        sarchValuePl: '商品コードまたは名前を検索',
        selectGroup: '商品を選択',
        selectGroup2: '得意先を選択',
        selected: '選択済み：商品',
        goodsName: '得意先名',
        goodsNumber: '商品コード',
        goodsNumberPl: '商品コードを選択してください',
        total: '総数：',
        message1: 'リストには削除されたまたは取引終了の得意先が存在します。削除してから再試行してください',
        emptyDyxTip: '得意先を検索する前にフィルター条件を選択してください',
        delete: '削除',
        edit: '編集',
        searchContent: '商品情報',
        searchPl: '商品コードまたは名前を入力してください',
        goodsCount: '商品数量',
        createUser: '作成者',
        updateTime: '更新時間',
        editGoods: '商品グループの編集',
        goodsCla: '商品カテゴリー',
        goodsGroup: '商品グループ',
        srx: '仕入先',
        tip: 'ヒント',
        tipContent: '保存後、指定された商品はゲストには見えなくなり、以下の設定された得意先のみが見えます',
        dyxPl: '得意先コードまたは名前を検索',
        dyxNumber: '得意先コード',
        ddz: '担当者',
        yetai: '業態',
        status: '状態',
        shangpin: '商品名',
        editVisible: '商品の可視性設定の編集',
        dyxCount: '得意先数'
      }
    }
  }
};